import { render, staticRenderFns } from "./ClassChild.vue?vue&type=template&id=3f8ecd8e&scoped=true"
import script from "./ClassChild.vue?vue&type=script&lang=js"
export * from "./ClassChild.vue?vue&type=script&lang=js"
import style0 from "./ClassChild.vue?vue&type=style&index=0&id=3f8ecd8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8ecd8e",
  null
  
)

export default component.exports